import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="min-h-screen flex flex-col justify-center px-4 md:px-8 py-4 md:py-12 max-w-5xl mx-auto text-center" data-id="element-34">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-35">
        <div className="inline-block bg-coral text-white border-2 border-coral-dark rounded-full px-3 py-1 md:px-5 md:py-2 text-[10px] md:text-sm font-bold mb-2 md:mb-6 shadow-md" data-id="element-36">
          🎨 EL SISTEMA N°1 DE ARTE PARA DOCENTES EN ARGENTINA
        </div>
        <h1 className="text-3xl md:text-6xl font-extrabold text-purple-deep mb-2 md:mb-4 leading-tight" data-id="element-37">
          TODO TU AÑO DE ARTE <span className="text-coral" data-id="element-38">RESUELTO.</span>
        </h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} src="https://cdn.magicpatterns.com/uploads/4fDTwNLpnwHUnQLBwLoAaJ/181.png" alt="Arte 360 — Plan Anual Completo" width={448} height={448}
      // @ts-expect-error fetchpriority is a valid HTML attribute not yet in TS lib dom
      fetchpriority="high" decoding="async" className="w-[170px] md:w-full max-w-[170px] md:max-w-md mx-auto mb-2 md:mb-6 drop-shadow-2xl h-auto" data-id="element-39" />

        <h2 className="text-sm md:text-2xl text-purple font-semibold mb-2 md:mb-4 max-w-3xl mx-auto leading-snug" data-id="element-40">
          Arte 360 — 12 tomos completos para docentes de Primaria y Secundaria
        </h2>
        <p className="hidden md:block text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-41">
          +180 actividades de Artes Visuales creadas para docentes que están
          hartos de improvisar. Listas para imprimir y entregar, diseñadas para
          la Argentina real: sin WiFi, sin presupuesto y con grupos difíciles.
        </p>
        <p className="md:hidden text-xs text-gray-600 mb-3 max-w-md mx-auto px-2" data-id="element-42">
          +180 actividades listas para imprimir. Para la Argentina real: sin
          WiFi y con grupos difíciles.
        </p>

        <div className="hidden md:flex flex-wrap justify-center gap-4 md:gap-8 mb-8 text-sm font-semibold text-purple-dark" data-id="element-43">
          <span className="flex items-center gap-1" data-id="element-44">✅ 100% PDF</span>
          <span className="flex items-center gap-1" data-id="element-45">⚡ Acceso inmediato</span>
          <span className="flex items-center gap-1" data-id="element-46">
            🖨️ Listo para fotocopiadora
          </span>
          <span className="flex items-center gap-1" data-id="element-47">
            🇦🇷 Aula argentina real
          </span>
        </div>

        <a href="#pricing" className="inline-block bg-coral hover:bg-coral-dark text-white font-bold text-sm md:text-xl py-3 px-6 md:py-5 md:px-10 rounded-full shadow-xl transform transition hover:scale-105 mb-3 md:mb-6" data-id="element-48">
          🎨 QUIERO MI ARTE 360 AHORA
        </a>

        <div className="flex flex-wrap justify-center gap-2 md:gap-6 text-[10px] md:text-sm text-purple" data-id="element-49">
          <span className="flex items-center gap-1" data-id="element-50">🔒 Pago seguro</span>
          <span className="flex items-center gap-1" data-id="element-51">✅ Garantía 7 días</span>
          <span className="flex items-center gap-1" data-id="element-52">💳 Mercado Pago</span>
        </div>
      </motion.div>
    </section>;
}
export function Stats() {
  return <section className="bg-purple-deep py-12 px-4" data-id="element-53">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-54">
        {[{
        num: '+500',
        text: 'DOCENTES EN TODO EL PAÍS'
      }, {
        num: '12',
        text: 'TOMOS LISTOS PARA USAR'
      }, {
        num: '4.9/5 ⭐',
        text: 'CALIFICACIÓN'
      }, {
        num: 'PRIM. Y SEC.',
        text: '🇦🇷 TODO EL PAÍS'
      }].map((stat, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} data-id="element-55">
            <div className="text-4xl md:text-5xl font-extrabold text-gold mb-2" style={{
          color: ['#F4B942', '#E85D4E', '#14A098', '#E91E63'][i]
        }} data-id="element-56">
              {stat.num}
            </div>
            <div className="text-white text-sm font-bold tracking-wider" data-id="element-57">
              {stat.text}
            </div>
          </motion.div>)}
      </div>
    </section>;
}
export function TestimonialsInitial() {
  const testimonials = [{
    initials: 'MG',
    quote: 'Organicé todo el año de Arte en una tarde. Nunca pensé que fuera posible.',
    author: 'Mariela G.',
    city: 'Córdoba',
    role: 'Primaria'
  }, {
    initials: 'LP',
    quote: 'Mis alumnos de secundaria por fin hacen cosas que les interesan. El material los engancha desde el primer minuto.',
    author: 'Laura P.',
    city: 'Rosario',
    role: 'Secundaria'
  }, {
    initials: 'RM',
    quote: 'Nunca más llegué a clase sin saber qué dar. Esto cambió todo.',
    author: 'Roberto M.',
    city: 'Buenos Aires',
    role: 'Prim. y Sec.'
  }];
  const accents = ['coral', 'teal', 'purple'];
  return <section className="py-16 px-4 bg-cream" data-id="element-58">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-59">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className={`bg-white p-8 rounded-2xl shadow-lg border-t-4 relative ${i === 0 ? 'border-coral' : i === 1 ? 'border-teal' : 'border-purple'}`} data-id="element-60">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg mb-4 ${i === 0 ? 'bg-coral' : i === 1 ? 'bg-teal' : 'bg-purple'}`} data-id="element-61">
              {t.initials}
            </div>
            <div className="text-gold text-lg mb-3 tracking-wider" aria-label="5 de 5 estrellas" data-id="element-62">
              ★★★★★
            </div>
            <p className="text-gray-700 italic mb-6" data-id="element-63">"{t.quote}"</p>
            <p className="text-sm font-bold text-purple-deep" data-id="element-64">
              — {t.author} | {t.city} | {t.role}
            </p>
          </motion.div>)}
      </div>
    </section>;
}
export function Problem() {
  const problems = ['Domingo a la noche sin saber qué dar el lunes', 'Los alumnos no trajeron materiales y la cooperadora no tiene fondos', 'La dirección te pide "innovación tecnológica" pero no hay WiFi', 'Horas perdidas buscando ideas en Pinterest que no aplican en Argentina', 'Planificaciones de apuro que el directivo igual te devuelve', 'Ponés plata de tu bolsillo para comprar témperas para tus alumnos'];
  return <section className="py-20 px-4 bg-cream-dark" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-purple-deep mb-10" data-id="element-67">
          Si sos docente de Arte en primaria o secundaria, esto te va a sonar
          familiar:
        </h2>
        <div className="space-y-4 mb-12" data-id="element-68">
          {problems.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 bg-white p-4 rounded-lg shadow-sm border-l-4 border-coral" data-id="element-69">
              <span className="text-xl mt-1" data-id="element-70">❌</span>
              <span className="text-lg text-purple-dark font-medium" data-id="element-71">{p}</span>
            </motion.div>)}
        </div>
        <h3 className="text-2xl md:text-3xl italic font-bold text-center text-purple-deep mb-10" data-id="element-72">
          "¿Cuántos domingos más vas a perder haciendo lo mismo?"
        </h3>

        {/* Extra Strategic CTA */}
        <div className="flex justify-center" data-id="element-73">
          <a href="#pricing" className="bg-teal hover:bg-teal-dark text-white font-bold py-4 px-8 rounded-full text-lg shadow-lg transform transition hover:scale-105 flex items-center gap-2" data-id="element-74">
            → MOSTRAME LA SOLUCIÓN
          </a>
        </div>
      </div>
    </section>;
}
export function ProductPresentation() {
  return <section className="py-20 px-4 bg-cream text-center" data-id="element-75">
      <div className="max-w-5xl mx-auto" data-id="element-76">
        <div className="inline-block bg-purple text-white border-2 border-purple-dark rounded-full px-5 py-2 text-sm font-bold mb-6 shadow-md" data-id="element-77">
          🎨 ARTE 360
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-purple-deep mb-6" data-id="element-78">
          El sistema completo de Arte para docentes argentinos
        </h2>
        <p className="text-xl text-purple font-medium mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-79">
          12 tomos organizados por grado y año.
          <br data-id="element-80" />
          180 actividades con secuencia completa.
          <br data-id="element-81" />
          6 bonus estratégicos de gestión.
          <br data-id="element-82" />
          Todo listo para usar desde hoy.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} src="https://cdn.magicpatterns.com/uploads/4fDTwNLpnwHUnQLBwLoAaJ/181.png" alt="Arte 360 — Plan Anual Completo" width={672} height={672} loading="lazy" decoding="async" className="w-full max-w-2xl mx-auto mb-16 drop-shadow-2xl h-auto" data-id="element-83" />

        <div className="flex flex-col md:flex-row justify-center gap-6" data-id="element-84">
          <div className="bg-coral text-white border-2 border-coral-dark rounded-xl p-6 font-bold text-lg shadow-md" data-id="element-85">
            ← PRIMARIA: 1° 2° 3° 4° 5° 6°
          </div>
          <div className="bg-teal text-white border-2 border-teal-dark rounded-xl p-6 font-bold text-lg shadow-md" data-id="element-86">
            ← SECUNDARIA: 1° 2° 3° 4° 5° 6°
          </div>
        </div>
      </div>
    </section>;
}
export function WhatYouGet() {
  const primaria = [{
    num: 'Tomo 1 — 1° Grado',
    title: 'Explorando el Trazo, la Forma y el Color',
    desc: 'Línea, punto, forma y color desde el juego. Actividades simples y lúdicas para los más chiquitos.'
  }, {
    num: 'Tomo 2 — 2° Grado',
    title: 'Formas, Texturas y Color',
    desc: 'Mayor complejidad compositiva. Collage, simetría y texturas naturales.'
  }, {
    num: 'Tomo 3 — 3° Grado',
    title: 'El Espacio y el Color Secundario',
    desc: 'Conceptos formales con autonomía creciente. Composición y mezcla de colores secundarios.'
  }, {
    num: 'Tomo 4 — 4° Grado',
    title: 'Composición, Volumen y Perspectiva',
    desc: 'Introducción al volumen y la tridimensionalidad. Boceto y perspectiva básica.'
  }, {
    num: 'Tomo 5 — 5° Grado',
    title: 'Arte y Cultura Visual',
    desc: 'El arte en contexto histórico y cultural. Análisis de imágenes y producción autónoma.'
  }, {
    num: 'Tomo 6 — 6° Grado',
    title: 'Diseño, Imagen y Lenguaje Visual',
    desc: 'Cierre de la primaria. Logo, tipografía, pixel art y arte latinoamericano.'
  }];
  const secundaria = [{
    num: 'Tomo 7 — 1° Año',
    title: 'El Lenguaje Visual y sus Elementos',
    desc: 'Punto, línea, forma, color y textura desde una mirada técnica y conceptual.'
  }, {
    num: 'Tomo 8 — 2° Año',
    title: 'Composición y Espacio Plástico',
    desc: 'Organización del plano, profundidad y relación figura-fondo.'
  }, {
    num: 'Tomo 9 — 3° Año',
    title: 'Color, Luz y Volumen',
    desc: 'Teoría del color avanzada, claroscuro y representación del volumen.'
  }, {
    num: 'Tomo 10 — 4° Año',
    title: 'Arte, Historia y Contexto',
    desc: 'Vanguardias artísticas, movimientos latinoamericanos y arte argentino.'
  }, {
    num: 'Tomo 11 — 5° Año',
    title: 'Diseño Gráfico y Comunicación Visual',
    desc: 'Identidad visual, diseño editorial y lenguaje publicitario.'
  }, {
    num: 'Tomo 12 — 6° Año',
    title: 'Arte Contemporáneo y Producción Propia',
    desc: 'Instalación, arte urbano, arte digital y proyecto de obra personal.'
  }];
  const Card = ({
    num,
    title,
    desc,
    color
  }: any) => <div className={`bg-white p-6 rounded-xl shadow-md border-t-4 hover:shadow-xl hover:-translate-y-1 transition transform ${color === 'coral' ? 'border-coral' : color === 'teal' ? 'border-teal' : color === 'purple' ? 'border-purple' : color === 'gold' ? 'border-gold' : 'border-pink-hot'}`} data-id="element-87">
      <div className={`font-bold text-lg mb-2 ${color === 'coral' ? 'text-coral' : color === 'teal' ? 'text-teal' : color === 'purple' ? 'text-purple' : color === 'gold' ? 'text-gold-dark' : 'text-pink-hot'}`} data-id="element-88">
        {num}
      </div>
      <h4 className="font-bold text-xl text-purple-deep mb-3" data-id="element-89">{title}</h4>
      <p className="text-gray-600 text-sm leading-relaxed" data-id="element-90">{desc}</p>
    </div>;
  const colors = ['coral', 'teal', 'purple', 'gold', 'pink', 'coral'];
  return <section className="py-20 px-4 bg-cream" data-id="element-91">
      <div className="max-w-6xl mx-auto" data-id="element-92">
        <h2 className="text-4xl font-bold text-center text-purple-deep mb-16" data-id="element-93">
          Lo que recibís:
        </h2>

        <div className="mb-20" data-id="element-94">
          <div className="text-center mb-10" data-id="element-95">
            <h3 className="text-3xl font-bold text-coral flex items-center justify-center gap-3 mb-2" data-id="element-96">
              <span data-id="element-97">📘</span> PRIMARIA — 6 TOMOS
            </h3>
            <p className="text-purple font-medium" data-id="element-98">
              Para docentes de Arte de 1° a 6° grado
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-99">
            {primaria.map((t, i) => <Card key={i} {...t} color={colors[i]} data-id="element-100" />)}
          </div>
        </div>

        <div data-id="element-101">
          <div className="text-center mb-10" data-id="element-102">
            <h3 className="text-3xl font-bold text-teal flex items-center justify-center gap-3 mb-2" data-id="element-103">
              <span data-id="element-104">📗</span> SECUNDARIA — 6 TOMOS
            </h3>
            <p className="text-purple font-medium" data-id="element-105">
              Para docentes de Arte de 1° a 6° año
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-106">
            {secundaria.map((t, i) => <Card key={i} {...t} color={colors[(i + 3) % colors.length]} data-id="element-107" />)}
          </div>
        </div>
      </div>
    </section>;
}
export function WhatEachTomeIncludes() {
  const items = ['15 actividades listas para imprimir y entregar', 'Consignas claras que el alumno entiende solo', 'Diseño en blanco y negro optimizado para fotocopiadora', 'Ejercicios graficados paso a paso', 'Guía docente de uso express', 'Progresión pedagógica por grado y año'];
  const itemBorders = ['border-coral', 'border-teal', 'border-purple', 'border-gold', 'border-pink-hot', 'border-coral'];
  return <section className="py-20 px-4 bg-cream-dark" data-id="element-108">
      <div className="max-w-5xl mx-auto" data-id="element-109">
        <h2 className="text-4xl font-bold text-center text-purple-deep mb-12" data-id="element-110">
          Cada tomo incluye:
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-111">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-white p-6 rounded-xl shadow-md flex items-start gap-4 border-l-4 ${itemBorders[i]}`} data-id="element-112">
              <span className="text-xl" data-id="element-113">✅</span>
              <span className="text-purple-dark font-medium" data-id="element-114">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    num: '01',
    icon: '🗓️',
    title: 'Planificaciones Anuales Listas',
    desc: '12 planificaciones anuales completas, una por grado y año. Personalizables en 5 minutos. Firmadas y listas para presentar ante cualquier directivo.',
    value: '$12.000',
    img: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=480&q=70'
  }, {
    num: '02',
    icon: '🎨',
    title: 'Guía de Proyectos de Muralismo',
    desc: 'Cómo organizar y ejecutar un mural colectivo desde cero. Con cronograma, materiales alternativos y técnicas adaptadas al presupuesto real.',
    value: '$10.000',
    img: 'https://images.unsplash.com/photo-1499892477393-f675706cbe6e?auto=format&fit=crop&w=480&q=70'
  }, {
    num: '03',
    icon: '📊',
    title: 'La Planilla Maestra de Notas',
    desc: 'Sistema de registro con semáforo automático para detectar alumnos en riesgo antes de que sea tarde.',
    value: '$9.000',
    img: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=480&q=70'
  }, {
    num: '04',
    icon: '📋',
    title: 'Pack de Seguimiento de Alumnos',
    desc: 'Fichas individuales, semáforo de curso y registro de proceso creativo. Todo el seguimiento en un vistazo.',
    value: '$8.000',
    img: 'https://images.unsplash.com/photo-1512314889357-e157c22f938d?auto=format&fit=crop&w=480&q=70'
  }, {
    num: '05',
    icon: '📝',
    title: 'El Banco de Rúbricas e Indicadores',
    desc: 'Rúbricas técnicas por nivel, indicadores observables y frases pre-escritas para boletines. Evaluá Arte sin subjetividad.',
    value: '$9.000',
    img: 'https://images.unsplash.com/photo-1503694978374-8a2fa686963a?auto=format&fit=crop&w=480&q=70'
  }, {
    num: '06',
    icon: '🗂️',
    title: 'Organización Semanal Docente',
    desc: 'El organizador del domingo. Horario por escuela, control de stock de materiales y tracker de pendientes. Bajá la ansiedad antes de que empiece.',
    value: '$8.000',
    img: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?auto=format&fit=crop&w=480&q=70'
  }];
  const bonusColors = ['coral', 'teal', 'gold', 'pink-hot', 'purple', 'coral'];
  return <section className="py-20 px-4 bg-purple-deep" data-id="element-115">
      <div className="max-w-6xl mx-auto" data-id="element-116">
        <div className="text-center mb-16" data-id="element-117">
          <h2 className="text-4xl md:text-5xl font-bold text-gold mb-4" data-id="element-118">
            Más los 6 Regalos Estratégicos
          </h2>
          <p className="text-xl text-cream mb-6" data-id="element-119">
            Incluidos en todas las ofertas — sin costo extra
          </p>
          <div className="inline-block bg-coral text-white font-bold px-6 py-2 rounded-full text-lg animate-pulse shadow-xl" data-id="element-120">
            🎁 BONUS GRATIS SOLO POR HOY
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-121">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-purple-dark border-t-4 rounded-xl overflow-hidden flex flex-col shadow-2xl ${bonusColors[i] === 'coral' ? 'border-coral' : bonusColors[i] === 'teal' ? 'border-teal' : bonusColors[i] === 'gold' ? 'border-gold' : bonusColors[i] === 'pink-hot' ? 'border-pink-hot' : 'border-cream'}`} data-id="element-122">
              <img src={b.img} alt={b.title} loading="lazy" decoding="async" width={480} height={320} className="w-full h-48 object-cover opacity-80 hover:opacity-100 transition" data-id="element-123" />
              <div className="p-6 flex flex-col flex-grow" data-id="element-124">
                <div className={`font-bold text-sm mb-2 tracking-widest ${bonusColors[i] === 'coral' ? 'text-coral' : bonusColors[i] === 'teal' ? 'text-teal' : bonusColors[i] === 'gold' ? 'text-gold' : bonusColors[i] === 'pink-hot' ? 'text-pink-hot' : 'text-cream'}`} data-id="element-125">
                  BONUS {b.num}
                </div>
                <h4 className="text-white font-bold text-xl mb-3 flex items-center gap-2" data-id="element-126">
                  {b.icon} {b.title}
                </h4>
                <p className="text-cream/70 text-sm mb-6 flex-grow" data-id="element-127">{b.desc}</p>
                <div className="text-white font-bold pt-4 border-t border-purple" data-id="element-128">
                  Valor:{' '}
                  <span className="line-through text-cream/50 font-normal" data-id="element-129">
                    {b.value}
                  </span>{' '}
                  <span className="text-gold ml-2" data-id="element-130">→ GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}